module.exports = __webpack_public_path__ + "img/cww_13.9e9524ed.jpg";